import { SubAPI } from "./SubAPI";
export class FeatureFlags extends SubAPI {
    list() { return this.fetcher.get("/api/feature-flags"); }
    upsert(input) { return this.fetcher.post("/api/feature-flag", input); }
}
